module.exports = __webpack_public_path__ + "static/img/banner-3.89497da.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/banner-3.png
// module id = awBO
// module chunks = 1